import React, { useState, useEffect } from 'react';
import useBodyClass from 'helpers/hooks/useBodyClass';
import { Form, Formik } from 'formik';
import { Columns, Column } from 'shared/Columns';
import Account from 'screens/Panel/screens/User/screens/Edit/components/Account/Account';
import Status from 'screens/Panel/screens/User/screens/Edit/components/Status/Status';
import Address from 'screens/Panel/screens/User/screens/Edit/components/Address/Address';
import Contact from 'screens/Panel/screens/User/screens/Edit/components/Contact/Contact';
import { Button } from 'lmc-ui-library';
import { fetchUser, saveUser } from 'screens/Panel/screens/User/screens/Edit/api';
import SaveIcon from 'shared/Icons/SaveIcon/SaveIcon';
import { mapApiDataForView, mapFormDataForSave } from 'screens/Panel/screens/User/screens/Edit/mapper';
import validationSchema from 'screens/Panel/screens/User/screens/Edit/Edit.validationSchema';
import { UserDataForView } from 'screens/Panel/screens/User/screens/Edit/mapper/types';
import { useHistory } from 'react-router-dom';
import { Loader } from 'components/Loader/Loader';

import styles from 'screens/Panel/screens/User/screens/Edit/Edit.module.scss';

type Props = {
  match: {
    params: {
      id: string;
    };
  };
};

const Edit: React.FC<Props> = ({ match }) => {
  const [userData, setUserData] = useState<UserDataForView | undefined>(undefined);
  const userId = match.params.id;
  const history = useHistory();

  useBodyClass(...styles['new-cm'].split(' '));

  useEffect(() => {
    fetchUser(userId).then(({ data }) => {
      const mappedData = mapApiDataForView(data);
      setUserData(mappedData);
    });
  }, [userId]);

  const handleSubmit = async (data: UserDataForView) => {
    try {
      await saveUser(userId, mapFormDataForSave(data));
      history.goBack();
    } catch (err) {
      console.error(err);
    }
  };

  return userData ? (
    <>
      <div className={styles.heading}>
        <p className={styles.title}>{userData.fullName}</p>
      </div>
      <Formik onSubmit={handleSubmit} initialValues={userData} validationSchema={validationSchema}>
        {() => (
          <Form className={styles.form}>
            <>
              <Columns>
                <Column>
                  <Account />
                  <Status />
                </Column>

                <Column>
                  <Address />
                  <Contact />
                </Column>
              </Columns>
            </>
            <div className={styles.savePanel}>
              <Button type="submit" mode="primary" borderVariant="rectangle" width="118px" className={styles.saveBtn}>
                Save
                <SaveIcon />
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  ) : (
    <Loader />
  );
};

export default Edit;
